<!--
 * @Author: your name
 * @Date: 2020-09-25 15:54:55
 * @LastEditTime: 2021-01-18 15:57:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mrc-base-server-view\src\components\mrc_ess_advanceFilterAndSearchInput\mrc_ess_filterOne.vue
-->
<template>
  <div>
    <v-expansion-panel-header>
      <v-badge :value="showSelect"
               left
               dot
               color="rgb(115,156,232)"
               offset-x="-4">
        {{ INT(item.field_description) }}
      </v-badge>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <!-- 逻辑运算 -->
      <mrc_ess_dictName v-model="logical_operator"
                        :rules="false"
                        :multiple="false"
                        :select_arr="operatorSelect"
                        @getData="getOperatorData"
                        :chips="false"
                        placeholder=" "
                        class="my-n2"></mrc_ess_dictName>

      <!-- 高级参照 -->
      <template v-if="item.field_reference && item.field_reference.indexOf('《') <= -1">
        <mrc_ess_prompt class="my-n2"
                        :disabledTwo="hasNull"
                        :chips="false"
                        :multiple="isMultiple"
                        v-model="logicalValue"
                        placeholder=" "
                        :obj="item.field_reference"
                        @getData="getPromptSelectData">
        </mrc_ess_prompt>
      </template>
      <!-- 数据字典 -->
      <template v-if="item.field_reference && item.field_reference.indexOf('《') > -1">
        <mrc_ess_dictName class="my-n2"
                          :disabledTwo="hasNull"
                          v-model="logicalValue"
                          :rules="false"
                          placeholder=" "
                          :multiple="isMultiple"
                          @getData="getDictName"
                          :dict_name="item.field_reference.replace('《', '').replace('》', '')"
                          :chips="false"></mrc_ess_dictName>
      </template>
      <!-- 输入框 -->
      <template v-if="!item.field_reference && item.field_type == 'string'">
        <mrc_ess_input class="my-n2"
                       :disabled="hasNull"
                       placeholder=" "
                       @input="getInputVal"
                       v-model="logical_value">
        </mrc_ess_input>
      </template>
      <!-- 数字输入框 -->
      <template v-if="!item.field_reference && item.field_type == 'int'">
        <div class="d-flex justify-space-between my-n2">
          <mrc_ess_NumInput :style="{ width: isMultiple ? '156px' : '100%' }"
                            v-model="logical_value"
                            :disabled="hasNull"
                            @changeNum="changeNum"></mrc_ess_NumInput>
          <mrc_ess_NumInput v-if="isMultiple"
                            :style="{ width: isMultiple ? '156px' : '100%' }"
                            v-model="logical_value_2"
                            :disabled="hasNull"
                            @changeNum="changeNum2"></mrc_ess_NumInput>
        </div>
      </template>

      <!-- 日期 -->
      <template v-if="!item.field_reference && item.field_type == 'datetime'">
        <mrc_ess_dateTimePicker class="my-n2"
                                v-if="!isMultiple"
                                ref="datetime"
                                type="datetime"
                                :disabled="hasNull"
                                :defaultTime="logical_value"
                                @change="datetimeChange"></mrc_ess_dateTimePicker>
        <mrc_ess_dateTimePicker v-else
                                class="my-n2"
                                ref="datetime"
                                :disabled="hasNull"
                                :defaultTime="logical_value_2"
                                type="datetimerange"
                                @change="datetimeChangeIsMultiple"></mrc_ess_dateTimePicker>
      </template>
    </v-expansion-panel-content>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  components: {},
  props: {
    item: {
      type: Object,
      default: () => { },
      required: true,
    },
    operatorSelect: {
      type: Array,
      default: () => [],
      required: true,
    },
    resetParams: {
      type: Boolean,
      default: false,
    },
    flag: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      field_name: '',
      logical_operator: '=',
      logical_value: '',
      table_name: '',
      logical_value_2: '',
      field_description: '',
    }
  },
  validations: {},
  computed: {
    hasNull () {
      return (
        this.logical_operator == 'isNotNull' ||
        this.logical_operator == 'isNull'
      )
    },
    isMultiple () {
      const arr = ['between', 'notBetween', 'in', 'notIn']
      return arr.includes(this.logical_operator)
    },
    showSelect () {
      const mark =
        ((this.isMultiple &&
          (((this.logical_value || this.logical_value == 0) &&
            this.logical_value_2) ||
            (this.logical_value && this.item.field_type == 'datetime'))) ||
          (this.logical_value && !this.isMultiple)) &&
        this.logical_operator
      return mark
    },
    logicalValue: {
      get () {
        if (this.isMultiple && this.logical_value) {
          if (this.logical_value.indexOf(',') > -1) {
            return this.logical_value.split(',')
          } else {
            return [this.logical_value]
          }
        }
        if (!this.isMultiple) {
          return this.logical_value
        }
        if (this.isMultiple && !this.logical_value) {
          return []
        }
      },
      set (val) {
        if (this.isMultiple) {
          this.logical_value = val.join(',')
        } else {
          this.logical_value = val
        }
      },
    },
  },
  created () { },
  watch: {
    isMultiple (val) {
      //  如果 多选单选切换了 就将之前的选择的清空 重新选择
      if (this.item.field_type == 'datetime') {
        this.$refs.datetime.datetime = ''
      }
      this.logical_value = ''
      this.logical_value_2 = ''
    },
    logical_operator (val) {
      if (this.hasNull) {
        this.logical_value = ''
        this.logical_value_2 = ''
      }
    },
    // 重置组件的参数
    resetParams (val) {
      if (val) {
        this.logical_operator = '='
        this.logical_value = ''
        this.logical_value_2 = ''
      }
    },
  },
  mounted () { },
  methods: {
    // 高级参照
    getPromptSelectData (val) {
      const obj = {
        field_name: this.item.field_name,
        logical_operator: this.logical_operator,
        logical_value: this.logical_value,
        table_name: this.item.table_name,
        field_description: this.item.field_description,
      }
      this.$emit('getData', obj)
    },
    getDictName (val) {
      const obj = {
        field_name: this.item.field_name,
        logical_operator: this.logical_operator,
        logical_value: this.logical_value,
        table_name: this.item.table_name,
        field_description: this.item.field_description,
      }
      this.$emit('getData', obj)
    },
    // 获取逻辑运算
    getOperatorData (val) {
      const obj = {
        field_name: this.item.field_name,
        logical_operator: val,
        logical_value: this.logical_value,
        table_name: this.item.table_name,
        field_description: this.item.field_description,
      }
      this.$emit('getData', obj)
    },
    // 时间单选
    datetimeChange (val) {
      this.logical_value = val
      const obj = {
        field_name: this.item.field_name,
        logical_operator: this.logical_operator,
        logical_value: this.logical_value + ':00',
        table_name: this.item.table_name,
        field_description: this.item.field_description,
      }
      this.$emit('getData', obj)
    },
    // 时间范围选择
    datetimeChangeIsMultiple (val) {
      this.logical_value = val
        .split('~~')
        .map((item) => item + ':00')
        .join(',')
      // this.logical_value = val.replace('~~', ',')
      const obj = {
        field_name: this.item.field_name,
        logical_operator: this.logical_operator,
        logical_value: this.logical_value,
        table_name: this.item.table_name,
        field_description: this.item.field_description,
      }
      this.$emit('getData', obj)
    },
    // 输入框
    getInputVal (val) {
      this.logical_value = val
      const obj = {
        field_name: this.item.field_name,
        logical_operator: this.logical_operator,
        logical_value: this.logical_value,
        table_name: this.item.table_name,
        field_description: this.item.field_description,
      }
      this.$emit('getData', obj)
    },
    // 数字类型改变
    changeNum (item) {
      const obj = {
        field_name: this.item.field_name,
        logical_operator: this.logical_operator,
        logical_value: this.isMultiple
          ? `${this.logical_value},${this.logical_value_2}`
          : this.logical_value,
        table_name: this.item.table_name,
        field_description: this.item.field_description,
      }
      this.$emit('getData', obj)
    },
    // 第二个数字类型改变
    changeNum2 (item) {
      // 区间的第二个要比第一个大
      if (item <= this.logical_value) {
        this.logical_value_2++
      }
      const obj = {
        field_name: this.item.field_name,
        logical_operator: this.logical_operator,
        logical_value: this.isMultiple
          ? `${this.logical_value},${this.logical_value_2}`
          : this.logical_value,
        table_name: this.item.table_name,
        field_description: this.item.field_description,
      }
      this.$emit('getData', obj)
    },
  },
}
</script>

<style scoped></style>
